import {createFileRoute} from "@tanstack/react-router";
import {TileSpread} from "../../../components/Tile.tsx";
import {Job} from "../../../rpc/webrpc-client.gen.ts";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";

// BROKEN WILL BE OBSOLETED BY DISPATCH

function ActiveJobSpread() {
    // const {data: jobsData, isSuccess: isJobsSuccess}
    //     = useRefreshableQuery({
    //     ...watchJobsForDispatchTqo,
    //     staleTime: DEFAULT_STALE_TIME,
    // });
    //
    // if (!isJobsSuccess) {
    //     return <SuspenseDialog message="fetching jobs"/>;
    // }

    // const jobs = jobsData.jobs;
    const jobs: Job[] = [];
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <TileSpread foods={jobs} estimatedHeight={0} Component={() => null}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/admin/job-spread")({
    component: ActiveJobSpread,
});

